import Card from "../../../../_components/Card";
import Campus from "../../../../types/Campus";
import {FCWithHTMLAttributes} from "../../../../types/reactTypes";
import clsMerge from "../../../../util/clsMerge";
import CampusHours from "../../../../_components/CampusHours";
import getCampusEmail from "@/app/util/getCampusEmail";

type CampusCardProps = {
	campus?: Campus | null;
};

const CampusCard: FCWithHTMLAttributes<CampusCardProps> = ({
	campus,
	className,
}) => {
	if (!campus) {
		return;
	}
	const campusEmail = getCampusEmail(campus.campusId);
	return (
		<Card className={clsMerge("border-gray-100 bg-gray-100", className)}>
			<h4>{`Contact ${campus.fullName}`}</h4>
			<p>
				<a href={`mailto:${campusEmail}`}>{campusEmail}</a>
			</p>
			<CampusHours hours={campus.hours} />
			<p>
				<a href={`tel:+1${campus.phoneNumber}`}>{campus.phoneNumber}</a>
			</p>
		</Card>
	);
};

export default CampusCard;
